import {lazy} from 'react';

const rfidRoutes = [
    {
        exact: true,
        path: '/rfid',
        component: lazy(() => import('../views/RFID/index'))
    },
    {
        exact: true,
        path: '/rfid/details',
        component: lazy(() => import('../views/RFID/RFIDDetails'))
    },
    {
        exact: true,
        path: '/rfid/history',
        component: lazy(() => import('../views/RFID/RFIDHistory'))
    },
    {
        exact: true,
        path: '/rfid/management',
        component: lazy(() => import('../views/RFID/RFIDManagement'))
    }
];

export default rfidRoutes;
